require("chartkick/chart.js");
import Rails from "rails-ujs";
window.Rails = Rails;
Rails.start();

import "@hotwired/turbo-rails";

document.addEventListener("turbo:frame-missing", (event) => {
  const { response, visit } = event.detail;
  event.preventDefault();
  visit(response);
});

import LocalTime from "./lib/local_time";
window.LocalTime = LocalTime;

import "./orgs/index";
